function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 220,
  height: 181
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H220V181H0V0Z",
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 76L110 126L220 76L110 26L0 76Z",
  fill: "#53DDB8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86 10.9091L110 21.8182V48L86 37.0909V10.9091Z",
  fill: "#44D0AB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86 10.9091L110 21.8182L134 10.9091L110 0L86 10.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134 10.9091L110 21.8182V48L134 37.0909V10.9091Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 30.9091L67 41.8182V68L43 57.0909V30.9091Z",
  fill: "#44D0AB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 30.9091L67 41.8182L91 30.9091L67 20L43 30.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91 30.9091L67 41.8182V68L91 57.0909V30.9091Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 49.9091L24 60.8182L48 49.9091L24 39L0 49.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 49.9091L24 60.8182V87L48 76.0909V49.9091Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 69.9091L67 80.8182L91 69.9091L67 59L43 69.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91 69.9091L67 80.8182V107L91 96.0909V69.9091Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129 30.9091L153 41.8182V68L129 57.0909V30.9091Z",
  fill: "#44D0AB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129 30.9091L153 41.8182L177 30.9091L153 20L129 30.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177 30.9091L153 41.8182V68L177 57.0909V30.9091Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172 49.9091L196 60.8182V87L172 76.0909V49.9091Z",
  fill: "#44D0AB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172 49.9091L196 60.8182L220 49.9091L196 39L172 49.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129 69.9091L153 80.8182V107L129 96.0909V69.9091Z",
  fill: "#44D0AB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129 69.9091L153 80.8182L177 69.9091L153 59L129 69.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 60.8182L0 49.9091V76V76.0909V101.364L14 107.727V202.364L110 246V126V99.8182L86 88.9091V115.091L67 106.455V80.8182L43 69.9091V95.5455L24 86.9091V60.8182Z",
  fill: "#41C6A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86 88.9091L110 99.8182L134 88.9091L110 78L86 88.9091Z",
  fill: "#60D7B7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196 60.8182L220 49.9091V76V76.0909V102.364L206 108.727V202.364L110 246V126V99.8182L134 88.9091V115.091L153 106.455V80.8182L177 69.9091V95.5455L196 86.9091V60.8182Z",
  fill: "#6DE2C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 145.364L110 151.727V246L96 239.636V145.364Z",
  fill: "#5BD7B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124 145.364L110 151.727V246L124 239.636V145.364Z",
  fill: "#52D1AF"
}));

var SvgTower = function SvgTower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 181,
    viewBox: "0 0 220 181",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tower.04213c05.svg";
export { ForwardRef as ReactComponent };